/**
 * Login Component
 * Renders login form and handles authentication
 */

import { signIn } from '../lib/auth.js';

export function renderLogin(container, onSuccess) {
  container.innerHTML = `
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <div class="login-icon">✨</div>
          <h1 class="login-title">Chorus</h1>
          <p class="login-subtitle">Multi-AI Chat Platform</p>
        </div>
        <form id="login-form" class="login-form">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" name="email" placeholder="you@example.com" required autocomplete="email" />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" name="password" placeholder="••••••••" required autocomplete="current-password" />
          </div>
          <div id="login-error" class="login-error" style="display:none"></div>
          <button type="submit" class="login-btn" id="login-btn">Sign In</button>
        </form>
      </div>
    </div>
  `;

  const form = container.querySelector('#login-form');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = form.querySelector('#email').value;
    const password = form.querySelector('#password').value;
    const errorEl = container.querySelector('#login-error');
    const btn = container.querySelector('#login-btn');
    
    btn.disabled = true;
    btn.textContent = 'Signing in...';
    errorEl.style.display = 'none';

    try {
      await signIn(email, password);
      onSuccess();
    } catch (error) {
      errorEl.textContent = error.message;
      errorEl.style.display = 'block';
      btn.disabled = false;
      btn.textContent = 'Sign In';
    }
  });
}
